<template>
    <div class="main-wrap" :class="{playing:state===GAME_STATE.PLAYING, noBackGround:dialogType===5}">
        <div class="mask-dark" :class="{active:gameRankingToggle||gameCertiToggle||gameHelpToggle||(preparedTime>0&&state===GAME_STATE.PLAYING)||dialogToggle}" @click="checkMaskClicked()"><span v-show="(preparedTime>0&&state===GAME_STATE.PLAYING)">{{this.preparedTime}}</span></div>
        <transition name="el-fade-in">
            <div class="menu-box" v-show="gameInitToggle">
                <img class='title-img' src="@/assets/img/title.png" alt="">
                <img class='pointer start-img hover' src="@/assets/img/start.png" alt="" @click="switchGameStep(GAME_STATE.FILL_INFORMATION)">
                <img class='pointer ranking-img hover' src="@/assets/img/ranking.png" alt="" @click="gameRankingToggle=true;gameInitToggle=false">
                <img class='pointer help-img hover' src="@/assets/img/help.png" alt="" @click="gameHelpToggle=true;gameInitToggle=false">
            </div>
        </transition>
        <transition name="el-fade-in">
            <div class="ranking-box" v-show="gameRankingToggle">
                <div class="ranking-content">
                    <h4>排行榜</h4>
                    <div class="data-box">
                        <div class="data-card">
                            <div class="card-slot pointer" :class="{active: lastClickedTab===1}" @click="clickRankingTab(1)">拼圖一 簡單</div>
                            <div class="card-slot pointer" :class="{active: lastClickedTab===2}" @click="clickRankingTab(2)">拼圖一 困難</div>
                            <div class="card-slot pointer" :class="{active: lastClickedTab===3}" @click="clickRankingTab(3)">拼圖二 簡單</div>
                            <div class="card-slot pointer" :class="{active: lastClickedTab===4}" @click="clickRankingTab(4)">拼圖二 困難</div>
                            <div class="card-slot pointer" :class="{active: lastClickedTab===5}" @click="clickRankingTab(5)">拼圖三 高手</div>
                        </div>
                        <div class="data-item" v-for="item, index in rankingData" :key="item.rData">
                            <div class="index">{{index+1}}</div>
                            <div class="name">{{item.name}}</div>
                            <!-- <div class="">{{item.school}}</div> -->
                            <div class="">{{switchSecondsToTime(item.time)}}</div>
                        </div>
                    </div>
                    <img class='pointer close hover' src="@/assets/img/close.svg" @click="switchGameStep(GAME_STATE.INIT)">
                </div>
            </div>
        </transition>
        <transition name="el-fade-in">
            <div class="form-box" v-show="state===GAME_STATE.FILL_INFORMATION" :class='{hide: dialogToggle}'>
                <div class="form-content">
                    <h3>請輸入個人資料</h3>
                    <div class="input-box">
                        <input type="text" :class='{block: dialogToggle}' v-model='userForm.name' name="name" id="userName" placeholder="你的名字是?">
                        <!-- <input type="text" :class='{block: dialogToggle}' v-model='userForm.school' name="school" id="userSchool" placeholder="你的學校是?">
                        <input type="text" :class='{block: dialogToggle}' v-model='userForm.grade' name="grade" id="userGrade" placeholder="你的年級是?"> -->
                    </div>
                    <button class="pointer hover" :class='{block: dialogToggle}' @click="switchGameStep(GAME_STATE.CHOOSE_DIFFICULTY)">我設定好了！</button>
                </div>
                <img src="@/assets/img/back.svg" :class="{active: dialogToggle}" class="back pointer hover" @click="switchGameStep(GAME_STATE.INIT)">
            </div>
        </transition>
        <transition name="el-fade-in">
            <div class="diff-box" v-show="state===GAME_STATE.CHOOSE_DIFFICULTY">
                <div class="diff-content">
                    <h3>歡迎<span style="color:#c96100;margin-left:10px;">{{this.userForm.name}}</span>，請選擇想挑戰的難度</h3>
                    <div class="diff-img-content">
                        <div class="diff-img">
                            <h4>拼圖一</h4>
                            <div class="item">
                                <img src="@/assets/img/diff-1.png" alt="">
                                <div class="btn-box">
                                    <button class='hover' @click="gameType=1;difficulty=1;switchGameStep(GAME_STATE.PLAYING);">簡單</button>
                                    <button class='hover' @click="gameType=1;difficulty=2;switchGameStep(GAME_STATE.PLAYING);">困難</button>
                                </div>
                            </div>
                        </div>
                        <div class="diff-img">
                            <h4>拼圖二</h4>
                            <div class="item">
                                <img src="@/assets/img/diff-2.png" alt="">
                                <div class="btn-box">
                                    <button class='hover' @click="gameType=2;difficulty=1;switchGameStep(GAME_STATE.PLAYING);">簡單</button>
                                    <button class='hover' @click="gameType=2;difficulty=2;switchGameStep(GAME_STATE.PLAYING);">困難</button>
                                </div>
                            </div>
                        </div>
                        <div class="diff-img">
                            <h4 class="sp">混合拼圖</h4>
                            <div class="item">
                                <img src="@/assets/img/diff-3.png" alt="">
                                <div class="btn-box">
                                    <button class="sp hover" @click="gameType=3;difficulty=1;switchGameStep(GAME_STATE.PLAYING);">高手</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <img src="@/assets/img/back.svg" alt="" class="back pointer hover" @click="switchGameStep(GAME_STATE.FILL_INFORMATION)">
            </div>
        </transition>
        <transition name="el-fade-in">
            <div class="help-box" v-show="gameHelpToggle">
                <h4>遊戲說明</h4>
                <div class="help-content">
                    <div class="left-box">
                        <img src="@/assets/img/help-img.png" alt="">
                    </div>
                    <div class="right-box">
                        <div class="target-group">
                            <h3 class="first">遊戲目標：</h3>
                            <span>嘗試在最短時間內拼完所選擇難度的拼圖，讓圖片能完整呈現。</span>
                        </div>
                        <div class="intro-group">
                            <h3>遊戲說明：</h3>
                            <ul>
                                <li>進入遊戲前，請填寫基本資料。</li>
                                <li>選擇想嘗試的拼圖圖片及困難度。</li>
                                <li>進入遊戲後，開始進行拼圖遊戲，並開始計時。</li>
                                <li>完成後，會顯示一張挑戰完成的獎狀，可存取圖片收集。</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="btn-box">
                    <button class="pointer hover" @click="switchGameStep(GAME_STATE.INIT)">我知道了</button>
                </div>
                <img class='pointer close hover' src="@/assets/img/close.svg" @click="switchGameStep(GAME_STATE.INIT)">
            </div>
        </transition>
        <transition name="el-zoom-in-center">
            <div class="canvas-wrap" id='canvas-wrap' v-show="state===GAME_STATE.PLAYING" :class="{dialog:dialogToggle}">
                <!-- <canvas id='game-canvas'></canvas> -->
                <div class="left-btn" :class="{active: preparedTime>0||dialogToggle}">
                    <img src="@/assets/img/back.svg" alt="" class="pointer hover" @click="showDialog(`返回後紀錄會消失，確定要返回嗎？`, 1)">
                    <img src="@/assets/img/home.svg" alt="" class="pointer hover" @click="showDialog(`確定要回首頁嗎？`, 2)">
                </div>
                <div class="right-btn" :class="{active: preparedTime>0||dialogToggle}">
                    <img src="@/assets/img/again.svg" alt="" class="pointer hover" @click="showDialog(`確定要重新挑戰嗎？`, 3)">
                    <img src="@/assets/img/give-up.svg" alt="" class="pointer hover" @click="showDialog(`確定要結束遊戲嗎？`, 4)">
                </div>
                <div class="timer" :class="{active:preparedTime>0||dialogToggle}">
                    {{playTime}}
                    <img src="@/assets/img/timer.svg" alt="">
                </div>
            </div>
        </transition>
        <transition name="el-zoom-in-center">
            <div class="dialog-box" v-show="dialogToggle">
                <div class="dialog-container">
                    <h4>{{dialogTitle}}</h4>
                    <div class="btn-box">
                        <button class="pointer hover" @click="checkDialogConfirmation();">確定</button>
                        <button class="pointer" v-show="dialogType!==5  " @click="dialogToggle=false">取消</button>
                    </div>
                </div>
                <img src="@/assets/img/close.svg" alt="" class="pointer hover" @click="dialogToggle=false">
            </div>
        </transition>
        <transition name="el-zoom-in-center">
            <div class="certi-box" v-show="gameCertiToggle" :class="{redirect: gameRedirectToggle}">
                <transition name="el-zoom-in-center">
                    <div class="lds-ellipsis" v-show="gameRedirectToggle"><div></div><div></div><div></div><div></div></div>
                </transition>
                <div class="certi-container" v-show="!gameRedirectToggle">
                    <img class='reward-img' id='reward-img' alt="">
                    <img class='congrat-img' src="@/assets/img/congrat.png" alt="">
                    <!-- <h3>恭喜 {{userForm.school}} {{userForm.grade}}年級 <span style="color:#c96100">{{userForm.name}} </span>同學，完成挑戰！</h3> -->
                    <h3>恭喜 <span style="color:#c96100">{{userForm.name}} </span>同學，完成挑戰！</h3>
                    <div class="info-box">
                        <div class="img" id="congrat-game-img"></div>
                        <div class="info">
                            <div class="detail">
                                <span>
                                    {{puzzleName}}
                                </span>
                                <span>
                                    &nbsp;&nbsp;&nbsp;{{puzzleDiff}}
                                </span>
                            </div>
                            <div class="time-box">
                                <span>花費時間</span>
                                <span style="font-size:40px;margin-top:5px">{{playTime}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="btn-box">
                        <button class="pointer hover" @click="redirectGameStep(1)">回首頁</button>
                        <button class="pointer hover" @click="redirectGameStep(2)">重新挑戰</button>
                    </div>
                </div>
            </div>
        </transition>
        <div class="game-prog">{{gameProgress}}</div>
        <div class="" @click="switchGameStep(GAME_STATE.ENDING)" style="display:none;position:absolute;top: 50px;left:50px;background-color:white">CLICK Me</div>
    </div>
</template>
<script>
import axios from 'axios';
export default {
    data() {
        return {
            gameInitToggle: true,
            gameHelpToggle: false,
            gameRankingToggle: false,
            gameDiffToggle: false,
            gameCertiToggle: false,
            gameRedirectToggle: false,
            dialogToggle: false,
            userForm:{
                name: '',
                school: '...',
                grade: '...',
            },
            state: 0,
            difficulty: 1,//1 or 2
            gameType: 1,
            playTime: "00:01",
            preparedTime: 1,
            dialogTitle: '',
            dialogType: 1,
            logoQueuing: false,
            GAME_STATE: Object.freeze({
                "INIT": 0,
                "FILL_INFORMATION": 1,
                "CHOOSE_DIFFICULTY": 2,
                "PLAYING": 3,
                "ENDING": 4,
            }),
            rankingData:[
                {
                    name: 'fakeData.Name',
                    school: 'fakeData.School',
                    time: 'fakeData.Time'
                },
            ],
            p5Script: null,
            p5Handler: null,
            lastClickedTab: 1,
            gameProgress: '0/0',
        }
    },
    methods:{
        getGameLevel(){
            switch (this.gameType) {
                case 1:
                    return (this.difficulty===1)?1:2;
                case 2:
                    return (this.difficulty===1)?3:4;
                case 3:
                    return 5;
                default:
                    return 0;
            }
        },
        getData(){
            // console.log(this.getGameLevel());
            axios.get(`https://bkhole.app/jigsaw-puzzles?level=${this.lastClickedTab}`,{
                params:{
                    _sort: 'time',
                    _limit: 3,
                }
            })
            .then((res)=>{
                this.rankingData = res.data;
                const intervalLength = 3 - this.rankingData.length;
                if(intervalLength > 0){
                    for(let i=0;i<intervalLength;i++){
                        this.rankingData.push({
                            name: '無',
                            school: '',
                            grade: '',
                            time: -1,
                        })
                    }
                }
            })
            .catch((err)=>{
            })
        },
        postData(){
            axios.post('https://bkhole.app/jigsaw-puzzles',{
                name: this.userForm.name,
                school: this.userForm.school,
                level: this.getGameLevel(),
                grade: this.userForm.grade,
                time: this.switchTimeToSeconds(this.playTime),
            }).then(res=>{
                console.log('post data res, ', res);
            }).catch(err=>{
                console.log('Some err happened!, ', err);
            })
        },
        switchGameStep(step=-1){
            if(step===-1) return;
            this.clearUI();
            this.clearP5();
            const vm = this;
            switch (step) {
                case this.GAME_STATE.INIT:
                    this.gameInitToggle = true;
                    break;
                case this.GAME_STATE.FILL_INFORMATION:
                    break;
                case this.GAME_STATE.CHOOSE_DIFFICULTY:
                    if(!this.userForm.name||!this.userForm.school||!this.userForm.grade){
                        this.showDialog('請填寫所有的欄位哦！', 5)
                        return;
                    }
                    this.difficultyToggle = true;
                    break;
                case this.GAME_STATE.PLAYING:
                    //here can be firet play and replay, so dont change difficulty and gameType.
                    this.preparedTime = 3;
                    this.playTime = "00:00";
                    this.p5Handler = new p5(this.p5Script, document.getElementById('canvas-wrap'));
                    break;
                case this.GAME_STATE.ENDING:
                    document.getElementById('congrat-game-img').style.backgroundImage = `url(${require(`@/assets/img/diff-${this.gameType}.png`)})`;
                    document.getElementById('reward-img').src = this.getRankingCompareToData()>0?require(`@/assets/img/reward-${this.getRankingCompareToData()}.png`):"";
                    this.gameCertiToggle = true;
                    this.logoQueuing = true;
                    this.postData();
                    setTimeout(()=>{
                        if(!this.logoQueuing){
                            return;
                        }
                        this.redirectGameStep();
                    }, 30000)
                    break;
                default:
                    break;
            }
            this.state = step;
        },
        redirectGameStep(id){
            this.gameRedirectToggle = true;
            this.logoQueuing = false;
            const vm = this;
            setTimeout(()=>{
                if(id===2){
                    vm.switchGameStep(vm.GAME_STATE.PLAYING);
                }else{
                    vm.switchGameStep(vm.GAME_STATE.INIT);
                }
            }, 5000)
        },
        getRankingCompareToData(){
            let s = this.switchTimeToSeconds(this.playTime);
            if (s < this.rankingData[0].time) return 1
            else if(s < this.rankingData[1].time) return 2;
            else if(s < this.rankingData[2].time) return 3;
            else return -1;
        },
        switchTimeToSeconds(secString){
            const min = secString.split(':')[0];
            const sec = secString.split(':')[1];
            return parseInt(min)*60 + parseInt(sec);
        },
        switchSecondsToTime(seconds){
            //Data form - "mm:ss"
            if(typeof(seconds)!=='number') return;
            return new Date(seconds * 1000).toISOString().substr(14, 5);
        },
        clearUI(){
            this.gameInitToggle = false;
            this.gameHelpToggle = false;
            this.gameRankingToggle = false;
            this.gameDiffToggle = false;
            this.gameCertiToggle = false;
            this.gameRedirectToggle = false;
            this.dialogType = 1;
        },
        clearP5(){
            if(this.p5Handler){
                this.p5Handler.remove();
            }
        },
        showDialog(title='',type=1){
            this.dialogToggle = true;
            this.dialogTitle = title;
            this.dialogType = type;
        },
        checkMaskClicked(){
            switch (this.state) {
                case this.GAME_STATE.PLAYING:
                    this.dialogToggle = false;
                    break;
                case this.GAME_STATE.INIT:
                    this.switchGameStep(this.GAME_STATE.INIT);
                    break;
                default:
                    break;
            }
        },
        checkDialogConfirmation(){
            switch (this.dialogType) {
                case 1:
                    this.switchGameStep(this.GAME_STATE.CHOOSE_DIFFICULTY);
                    break;
                case 2:
                    this.switchGameStep(this.GAME_STATE.INIT);
                    break;
                case 3:
                    this.switchGameStep(this.GAME_STATE.PLAYING);
                    break;
                case 4:
                    this.switchGameStep(this.GAME_STATE.INIT);
                    break;
                case 5:
                    //fill information hint
                    break;
                default:
                    break;
            }
            this.dialogToggle = false;
        },
        clickRankingTab(id){
            this.lastClickedTab = id;
            this.getData();
        }
    },
    computed:{
        puzzleName(){
            if(this.gameType===1){
                return "拼圖一";
            }
            else if(this.gameType===2){
                return "拼圖二";
            }
            else{
                return "混合拼圖";
            }
        },
        puzzleDiff(){
            if(this.difficulty===1){
                return "簡單";
            }
            else if(this.difficulty===2){
                return "困難";
            }
            else if(this.gameType===3){
                return "高手";
            }
        }
    },
    mounted(){
        this.getData();
        //prevent right-clicked event
        document.addEventListener('contextmenu', event => event.preventDefault());
        //P5 scripts logic setup.
        window.state = this.state;
        let ip5 = p5;//original p5
        let solvedIcon;
        this.p5Script = p5 =>{
            const vm = this;
            let cxs;
            let timer_prepare = 0 ,timer_playing = 0, timer_playSec = 0;
            let bg;
            let puzzle1, puzzle2;
            let currentImage, currentImage2;
            let solvedEffects = [];

            function getOffset(){
                const innerOffset = 50, yOffset = 50;
                return {
                    x: p5.displayWidth/2 - currentImage.width/2,
                    y: (p5.displayHeight/2 - currentImage.height/2) + yOffset,
                    x1: p5.displayWidth/2 - innerOffset - currentImage.width,
                    x2: p5.displayWidth/2 + innerOffset,
                }
            } 
            class Grids {
                constructor(pid, side, x, y, w, h, id) {
                    this.side = side;
                    this.x = x;//iterator x
                    this.y = y;//iterator y
                    this.pos = {
                        x: (vm.gameType===3)?(pid===1)?(getOffset().x1):(getOffset().x2):getOffset().x,
                        y: getOffset().y+h*y,
                    }
                    this.w = w;
                    this.h = h;
                    this.id = id;//grid index
                    this.pid = pid;//puzzle id
                    this.attached = false;
                    this.solved = false;
                }
                draw(){
                    this.update();
                    const textOffset = 5;
                    p5.fill("#ebebeb");
                    p5.stroke('#c2a979');
                    p5.strokeWeight(1);
                    p5.rect(this.pos.x, this.pos.y, this.w, this.h);      
                }
                update(){
                    const x0 = (vm.gameType===3)?(this.pid===1)?(getOffset().x1):(getOffset().x2):getOffset().x;
                    this.pos.x = x0+this.w*this.x;
                    this.pos.y = getOffset().y+this.h*this.y;
                }
            }
            class Piece {
                constructor(pid, pos, img, i, id) {
                    this.pos = pos;//x, y
                    this.img = img;
                    this.i = i;
                    this.id = id;
                    this.pid = pid;//puzzle id
                    this.width = img.width;//w
                    this.height = img.height;//h
                    this.dragging = false;
                    this.solved = false;
                    this.attachedGrid = null;
                }
                draw() {
                    const g = this.pid===1?puzzle1.grids.find(e=>e.id===this.id):puzzle2.grids.find(e=>e.id===this.id);
                    let minimize = (vm.difficulty===2) || vm.gameType===3;
                    let iconSize = minimize ? 12 : 24; 
                    if(this.solved){
                        p5.image(this.img, g.pos.x, g.pos.y);
                        p5.image(solvedIcon, g.pos.x + 5, g.pos.y + 5, iconSize, iconSize);
                    }else{
                        p5.image(this.img, this.pos.x, this.pos.y);
                    }
                    if(this.dragging){
                        p5.noFill();
                        p5.stroke('white');
                        p5.strokeWeight(5);
                        p5.rect(this.pos.x,this.pos.y,this.width,this.height);
                    }
                    //here
                }
                hits(hitpos) {
                    if (hitpos.x > this.pos.x &&
                        hitpos.x < this.pos.x + this.width &&
                        hitpos.y > this.pos.y &&
                        hitpos.y < this.pos.y + this.height) {
                        return true;
                    }
                    return false;
                }
            }
            class Puzzle {
                constructor(id, img, side) {
                    this.id = id;//puzzle1 or puzzle2
                    this.img = img;
                    this.side = side;
                    this.isDragging = false;
                    this.canPlay = true;
                    this.pieces = [];
                    this.grids = [];
                    this.width = img.width;
                    this.height = img.height;
                    this.w = this.width / side;
                    this.h = this.height / side;
                    this.solvedPuzzles = 0;
                    this.showHint = true;
                    this.setGrids();
                    this.setPieces();
                    setTimeout(()=>{
                        this.unattachGrids();
                    }, 1500)
                }
                setPieces() {
                    let count = 1;
                    for (let x = 0; x < this.side; x++) {
                        for (let y = 0; y < this.side; y++) {
                            let img = p5.createImage(this.w, this.h);
                            img.copy(this.img, this.w * x, this.h * y, this.w, this.h, 0, 0, this.w, this.h);
                            let pos = this.randomPos();
                            let index = x + y * this.side;
                            this.pieces.push(new Piece(this.id, pos, img, index, count++));
                        }
                    }
                }
                randomPos() {
                    let x, y;
                    while(true){
                        x = p5.random(100, p5.displayWidth - 150);
                        y = p5.random(100, p5.displayHeight - 150);
                        if(vm.gameType===3){
                            //puzzle1
                            if(overlaps(
                                {x1: x, x2: x + this.w, y1: y, y2: y + this.h},
                                {x1: getOffset().x1, x2: getOffset().x1+this.width, y1: getOffset().y, y2: getOffset().y+this.height}
                            )){
                                continue;
                            }
                            //puzzle2
                           if(overlaps(
                                {x1: x, x2: x + this.w, y1: y, y2: y + this.h},
                                {x1: getOffset().x2, x2: getOffset().x2+this.width, y1: getOffset().y, y2: getOffset().y+this.height}
                            )){
                                continue;
                            }
                            return p5.createVector(x, y);
                        }
                        else
                        {
                            if(overlaps(
                                {x1: x, x2: x + this.w, y1: y, y2: y + this.h},
                                {x1: getOffset().x, x2: getOffset().x+this.width, y1: getOffset().y, y2: getOffset().y+this.height}
                            )){
                                continue;
                            }
                            return p5.createVector(x, y);
                        }
                    }
                    function overlaps(a, b) {
                        if (a.x1 >= b.x2 || b.x1 >= a.x2) return false;
                        if (a.y1 >= b.y2 || b.y1 >= a.y2) return false;
                        return true;
                    }
                }
                drawImage() {
                    const x0 = (vm.gameType===3)?(this.id===1)?(getOffset().x1):(getOffset().x2):getOffset().x;
                    p5.image(this.img, x0, getOffset().y);
                }
                drawLayout() {
                    const x0 = (vm.gameType===3)?(this.id===1)?(getOffset().x1):(getOffset().x2):getOffset().x;
                    p5.noFill();
                    p5.stroke("#c2a979");
                    p5.strokeWeight(13); 
                    p5.rect(x0 - 1, getOffset().y - 1, this.width + 1, this.height + 1);
                }
                drawGrids(){
                    this.grids.forEach(r => r.draw());
                }
                drawPieces(){
                    this.pieces.forEach(r => r.draw());
                }
                drawHint(){
                    const x0 = (vm.gameType===3)?(this.id===1)?(getOffset().x1):(getOffset().x2):getOffset().x;
                    if(this.showHint){
                        p5.noStroke();
                        p5.fill('#6b6b6b');    
                        p5.textSize(36);
                        p5.text(`請大家按照線索把拼圖拼到這裡`, x0 + 42, getOffset().y+this.height/2); 
                    }
                    p5.stroke(10);
                    p5.fill('#603f2e');    
                    p5.textSize(40);
                    p5.text(`拼圖${this.id===1?"一":"二"}`, x0 + this.width/2 - 50, getOffset().y-35); 
                }
                setGrids(){
                    const w =  this.width / this.side;
                    const h =  this.height / this.side;
                    let count = 1;
                    for (let x = 0; x < this.side; x++) {
                        for (let y = 0; y < this.side; y++) {
                            this.grids.push(new Grids(this.id, this.side, x, y, w, h, count++));
                        }
                    }
                }
                mousePressed(x, y) {
                    if (this.canPlay) {
                        let m = p5.createVector(x, y);
                        let index;
                        for(let i=0;i<this.pieces.length;i++){
                            let p = this.pieces[i];
                            if(p.solved) continue;
                            if(p.hits(m)){
                                this.clickOffset = ip5.Vector.sub(p.pos, m);
                                this.isDragging = true;
                                this.dragPiece = p;
                                this.dragPiece.dragging = true;
                                index = i;
                                break;
                            }
                        }
                        if (this.isDragging) {
                            this.putOnTop(index);
                        }
                    }
                }
                mouseDragged(x, y) {
                    //here adjustify the offset between mouse pos and clicked puzzle piece.
                    if (this.isDragging) {
                        let m = p5.createVector(x, y);
                        this.dragPiece.pos.set(m).add(this.clickOffset);
                        this.dragPiece.dragging = true;
                    }
                }
                mouseReleased() {
                    if (this.isDragging) {
                        if(this.dragPiece.attachedGrid!==null){
                            this.dragPiece.attachedGrid.attached = false;
                        }
                        this.isDragging = false;
                        this.attachToClosestGrid(this.dragPiece);
                        this.dragPiece.dragging = false;
                    }
                }
                putOnTop(index) {
                    this.pieces.splice(index, 1);
                    this.pieces.push(this.dragPiece);
                }
                attachToClosestGrid(p){
                    let minimize = (vm.difficulty===2) || vm.gameType===3;
                    let closestGrid = this.findClosestGrid(p.pos.x,p.pos.y,minimize?20:35);
                    if(closestGrid!==null){
                        if(!closestGrid.attached){
                            p.pos.x = closestGrid.pos.x;
                            p.pos.y = closestGrid.pos.y;
                            p.attachedGrid = closestGrid;;
                            closestGrid.attached = true;
                            this.checkSolvedPuzzle(p.id);
                        }
                    }
                }
                checkSolvedPuzzle(id){
                    let p = this.pieces.find(e=>e.id===id);
                    let g = this.grids.find(e=>e.id===id);
                    if(this.isPieceInCorrectGrid(p,g)){
                        this.solvedPuzzles++;
                        p.solved = true;
                        g.solved = true;
                        // solvedEffects.push(new SolvedEffects(g.pos.x+g.w/2,g.pos.y+g.h/2, g.w, g.h, 500));
                        vm.gameProgress = `${this.solvedPuzzles}/${this.side*this.side}`;
                        // console.log(`拼圖${this.id}進度: ${this.solvedPuzzles}/${this.side**2}`);
                    }
                }
                findClosestGrid(x=0,y=0,minimumErrDistance=1){
                    for(let i=0;i<this.grids.length;i++){
                        let g = this.grids[i];
                        if(g.solved) continue;
                        if((Math.abs(g.pos.x + g.w/2 - x) < minimumErrDistance) && (Math.abs(g.pos.y + g.h/2 - y) < minimumErrDistance)){
                            return g;
                        }
                        if((Math.abs(g.pos.x - x) < minimumErrDistance) && (Math.abs(g.pos.y - y) < minimumErrDistance)){
                            return g;
                        }
                    }
                    return null;
                }
                isPieceInCorrectGrid(p, g) {
                    const minimumErrDistance = 1;
                    return (Math.abs(p.pos.x - g.pos.x) < minimumErrDistance) && (Math.abs(p.pos.y - g.pos.y) < minimumErrDistance)
                }
                unattachGrids(){
                    this.grids.forEach(e=>e.attached=false);
                }
            }
            p5.preload = () =>{
                bg = p5.loadImage(require("@/assets/img/wood.png"));
                let image1;
                let image2;
                solvedIcon = p5.loadImage(require("@/assets/img/solved.svg"));
                const imageFitSize = async () => {
                    const w = p5.displayWidth;
                    if(vm.gameType===3){
                        if(w < 1200){
                            image1 = await p5.loadImage(require("@/assets/img/puzzle1-400.png"));
                            image2 = await p5.loadImage(require("@/assets/img/puzzle2-400.png"));
                        }else{
                            image1 = await p5.loadImage(require("@/assets/img/puzzle1-500.png"));
                            image2 = await p5.loadImage(require("@/assets/img/puzzle2-500.png"));
                        }
                    }
                    else{
                        if(w > 800){
                            image1 = await p5.loadImage(require("@/assets/img/puzzle1-600.png"));
                            image2 = await p5.loadImage(require("@/assets/img/puzzle2-600.png"));
                        }
                        else if(w > 700){
                            image1 = await p5.loadImage(require("@/assets/img/puzzle1-500.png"));
                            image2 = await p5.loadImage(require("@/assets/img/puzzle2-500.png"));
                        }
                        else if(w > 600){
                            image1 = await p5.loadImage(require("@/assets/img/puzzle1-400.png"));
                            image2 = await p5.loadImage(require("@/assets/img/puzzle2-400.png"));
                        }
                    }
                }
                imageFitSize().then(()=>{
                    currentImage = (this.gameType===2)?image2:image1;
                    currentImage2 = this.gameType===3?image2:null;
                });
            }
            p5.setup = () => {
                console.log('p5 initialize', p5);
                cxs = p5.createCanvas(p5.displayWidth,p5.displayHeight);
                console.log('canvas, ', cxs);
                puzzle1 = new Puzzle(1, currentImage, (this.difficulty===1&&this.gameType!==3)?5:8);
                puzzle2 = (this.gameType === 3) ? new Puzzle(2, currentImage2, 8):null;
            };
            p5.draw = () => {
                if(vm.preparedTime>0){
                    if(p5.millis()>=1000+timer_prepare){
                        vm.preparedTime--;
                        timer_prepare = p5.millis();
                    }
                    return;
                }//notice when it done, the mills is 3000 (vm.preparedTime * 1000)
                p5.background(bg);
                if(p5.millis()<=9000){//3000 + 3000
                    if(puzzle1) puzzle1.drawImage();
                    if(puzzle2) puzzle2.drawImage();
                    vm.playTime = "00:0" + parseInt(4 - (p5.millis()-6000)/1000);
                    return;
                }//notice when it done, the mills is 6000 (vm.preparedTime * 1000) + showImageTime(3000)
                if(p5.millis()>=1000+timer_playing){
                    timer_playSec++;
                    vm.playTime = vm.switchSecondsToTime(timer_playSec);
                    timer_playing = p5.millis();
                }
                if(p5.millis()>=14000){//6000 + 5000
                    if(puzzle1) puzzle1.showHint = false;
                    if(puzzle2) puzzle2.showHint = false;
                }
                if(puzzle1){
                    puzzle1.drawLayout();
                    puzzle1.drawGrids();
                    puzzle1.drawHint();
                    puzzle1.drawPieces();
                }
                if(vm.gameType===3&&puzzle1&&puzzle2){
                    puzzle1.drawLayout();
                    puzzle2.drawLayout();
                    puzzle1.drawGrids();
                    puzzle2.drawGrids()
                    puzzle1.drawHint();
                    puzzle2.drawHint();
                    puzzle1.drawPieces();
                    puzzle2.drawPieces();
                }
                if(solvedEffects.length){
                    solvedEffects.forEach(e=>e.draw());
                }
                if(vm.gameType===3){
                    if(puzzle1.solvedPuzzles===puzzle1.side**2&&puzzle2.solvedPuzzles===puzzle2.side**2){
                        vm.switchGameStep(vm.GAME_STATE.ENDING);
                    }
                }else{
                    if(puzzle1.solvedPuzzles===puzzle1.side**2){
                        vm.switchGameStep(vm.GAME_STATE.ENDING);
                    }
                }
            };
            p5.windowResized = () => {
                p5.resizeCanvas(p5.displayWidth, p5.displayHeight);
            }
            p5.mousePressed = () => {
                puzzle1.mousePressed(p5.mouseX, p5.mouseY);
                if(puzzle2&&!puzzle1.isDragging)puzzle2.mousePressed(p5.mouseX, p5.mouseY);
                vm.checkMaskClicked();
            }
            p5.mouseDragged = () => {
                puzzle1.mouseDragged(p5.mouseX, p5.mouseY);
                if(puzzle2&&!puzzle1.isDragging) puzzle2.mouseDragged(p5.mouseX, p5.mouseY);
            }
            p5.mouseReleased = () => {
                puzzle1.mouseReleased();
                if(puzzle2&&!puzzle1.isDragging) puzzle2.mouseReleased();
            }
        }
    },
    destroyed(){
        this.clearP5();
    }
}
</script>
<style lang="scss" scoped>
@import '@/assets/css/main.scss';
</style>